import { findFriendRecordForPlayer } from "./friendIdentity";

function toTimestamp(value) {
  if (value == null || value === "") return null;
  if (typeof value === "number" && Number.isFinite(value)) return value;

  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : null;
}

function pickNewerPresence(player, friendRecord) {
  const playerTs = toTimestamp(player?.lastOnlineUpdate);
  const friendTs = toTimestamp(friendRecord?.friendData?.lastOnlineUpdate);

  if (playerTs != null && friendTs != null) {
    return friendTs > playerTs ? "friend" : "player";
  }

  if (friendTs != null) return "friend";
  if (playerTs != null) return "player";
  return null;
}

function normalizePresenceValue(isOnline, playerStatus) {
  if (playerStatus === "offline") return false;
  if (isOnline === false) return false;
  if (isOnline === true) return true;
  return undefined;
}

export function resolveLobbyPlayerOnlineState({ player, friendRecord }) {
  const playerPresence = normalizePresenceValue(
    player?.isOnline,
    player?.playerStatus
  );
  const friendPresence = normalizePresenceValue(
    friendRecord?.friendData?.isOnline,
    friendRecord?.friendData?.playerStatus
  );
  
  if (playerPresence === false && friendPresence === true) {
    return false;
  }

  const newerPresenceSource = pickNewerPresence(player, friendRecord);
  if (newerPresenceSource === "friend" && friendPresence !== undefined) {
    return friendPresence;
  }
  if (newerPresenceSource === "player" && playerPresence !== undefined) {
    return playerPresence;
  }

  if (playerPresence === false || friendPresence === false) return false;
  if (playerPresence === true) return true;
  if (friendPresence === true) return true;
  return undefined;
}

export function listOfflinePartyMembers({
  members,
  currentUserId,
  friends,
} = {}) {
  if (!Array.isArray(members) || members.length === 0) return [];

  const selfId = currentUserId != null ? String(currentUserId) : "";

  return members.filter((member) => {
    if (!member) return false;
    if (selfId && String(member.userId) === selfId) return false;

    const friendRecord = findFriendRecordForPlayer(friends, member);
    return (
      resolveLobbyPlayerOnlineState({ player: member, friendRecord }) !== true
    );
  });
}

export function buildOfflinePartyQueueToast(offlineMembers) {
  if (!Array.isArray(offlineMembers) || offlineMembers.length === 0) {
    return null;
  }

  if (offlineMembers.length === 1) {
    const name = String(offlineMembers[0]?.nickname || "").trim();
    if (name) return `Can't start queue — ${name} is offline.`;
  }

  return "Can't start queue while a party member is offline.";
}
